export {useSvgLoader} from "./useSvgLoader";
